var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('rect',{staticClass:"interactive-rect",class:{ 'hover-enabled': _vm.shouldShowHover },attrs:{"x":_vm.item.position_x,"y":_vm.item.position_y,"width":_vm.item.width,"height":_vm.item.height},on:{"click":function($event){return _vm.openDialog()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }